<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import Dropdown from 'primevue/dropdown'
import { getSupplierList } from '@/api/suppliers'
import type { Supplier } from '@/types/supplier-types'
import { useField } from 'vee-validate'
import { RouterLink } from 'vue-router'

const props = withDefaults(
  defineProps<{
    modelValue?: Supplier | string
    label?: string
    placeholder?: string
    inputName: string
    disabled?: boolean
  }>(),
  {
    label: 'Knitting Supplier:',
    placeholder: 'Select who knitted it'
  }
)

const emit = defineEmits(['update:modelValue'])
const { value, errorMessage } = useField<Supplier | string>(props.inputName)

const computedValue = computed({
  get: () => props.modelValue || '',
  set: (newVal: Supplier | string) => {
    value.value = newVal
    emit('update:modelValue', newVal)
  }
})

const suppliers = ref<Supplier[]>([])

const label = computed(() =>
    props.inputName === 'finishingSupplierId' ? 'Finishing Supplier:' : 'Knitting Supplier:'
)

const placeholder = computed(() =>
    props.inputName === 'finishingSupplierId' ? 'Select finishing supplier' : 'Select who knitted it'
)

onMounted(async () => {
  suppliers.value = await getSupplierList()
  const techknitalSupplier = suppliers.value.find(knittingSupplier => knittingSupplier.id === '8bbf83e0-9c72-45bc-b065-b982ba25a9c5')
  if (techknitalSupplier && props.inputName === 'knittingSupplier') {
    computedValue.value = techknitalSupplier
  }
})
</script>

<template>
  <div class="flex flex-col gap-2">
    <label for="supplier">{{ label }}</label>
    <p v-if="disabled" class="py-2 font-medium text-[15px] bg-gray-50 rounded-lg px-2">
      <RouterLink
          :to="`/suppliers/${computedValue}`"
          class="font-medium text-neutral-800 hover:underline"
      >
        {{ typeof computedValue === 'string' ? suppliers?.find((knittingSupplier) => knittingSupplier.id === computedValue)?.name : computedValue?.name }}
      </RouterLink>
    </p>
    <Dropdown
      v-else
      id="knittingSupplier"
      v-model="computedValue"
      :options="suppliers"
      option-label="name"
      :placeholder="placeholder"
      :invalid="!!errorMessage"
    />
  </div>
</template>

<style scoped></style>
